import {Component, Input, OnInit} from "@angular/core";
import {Kpi} from "../../../../model/kpi";
import {DeviceMeasurement} from "../../../../model/device-measurement";
import {AssetMeasurement} from "../../../../model/asset-measurement";
import {KpisService} from "../../../../services/kpis.service";
import {SortOrder} from '../../../../model/sort-order';

@Component({
  selector: 'app-kpi-components',
  templateUrl: './kpi-components.component.html',
  styleUrls: ['./kpi-components.component.scss']
})
export class KpiComponentsComponent implements OnInit {

  @Input()
  public kpi: Kpi;

  public deviceMeasurements: DeviceMeasurement[];
  public deviceMeasurementsFirst: number;
  public deviceMeasurementsRows: number;
  public totalDeviceMeasurements: number;
  public loadingDeviceMeasurements: boolean;

  public assetMeasurements: AssetMeasurement[];
  public assetMeasurementsFirst: number;
  public assetMeasurementsRows: number;
  public totalAssetMeasurements: number;
  public loadingAssetMeasurements: boolean;

  public kpis: Kpi[];
  public kpisFirst: number;
  public kpisRows: number;
  public totalKpis: number;
  public loadingKpis: boolean;

  constructor(private kpisService: KpisService) {
    this.deviceMeasurements = [];
    this.deviceMeasurementsFirst = 0;
    this.deviceMeasurementsRows = 5;
    this.loadingDeviceMeasurements = true;

    this.assetMeasurements = [];
    this.assetMeasurementsFirst = 0;
    this.assetMeasurementsRows = 5;
    this.loadingAssetMeasurements = true;

    this.kpis = [];
    this.kpisFirst = 0;
    this.kpisRows = 5;
    this.loadingKpis = true;
  }

  ngOnInit(): void {
    this.loadMeasurements();
  }

  private loadMeasurements(): void {
    this.loadDeviceMeasurements();
    this.loadAssetMeasurements();
    this.loadKpiMeasurements();
  }

  public loadDeviceMeasurements(event?: any): void {
    this.loadingDeviceMeasurements = true;
    const pd = this.buildPaginationData(this.deviceMeasurementsFirst, this.deviceMeasurementsRows, event);
    this.kpisService.getDeviceMeasurementsOfKpi(this.kpi.uuid, pd.offset, pd.limit, pd.filters).subscribe(response => {
      this.deviceMeasurements = [...response.deviceMeasurements];
      this.totalDeviceMeasurements = response.totalElements;
      this.loadingDeviceMeasurements = false;
    });
  }

  public loadAssetMeasurements(event?: any): void {
    this.loadingAssetMeasurements = true;
    const pd = this.buildPaginationData(this.assetMeasurementsFirst, this.assetMeasurementsRows, event);
    this.kpisService.getAssetMeasurementsOfKpi(this.kpi.uuid, pd.offset, pd.limit, pd.filters).subscribe(response => {
      this.assetMeasurements = response.assetMeasurements;
      this.totalAssetMeasurements = response.totalElements;
      this.loadingAssetMeasurements = false;
    });
  }

  public loadKpiMeasurements(event?: any): void {
    this.loadingKpis = true;
    const pd = this.buildPaginationData(this.kpisFirst, this.kpisRows, event);
    this.kpisService.getKpisOfKpi(this.kpi.uuid, pd.offset, pd.limit, pd.filters).subscribe(response => {
      this.kpis = response.kpis;
      this.totalKpis = response.totalElements;
      this.loadingKpis = false;
    });
  }

  private buildPaginationData(first: number, rows: number, event?: any): { offset: number, limit: number, filters: any } {
    let filters, offset, limit;
    if (event) {
      filters = {
        sortField: event.sortField,
        sortOrder: event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING
      };
      offset = event.first / event.rows;
      limit = event.rows;
    } else {
      filters = { sortField: 'name', sortOrder: SortOrder.DESCENDING };
      offset = first / rows;
      limit = rows;
    }
    return { offset, limit, filters };
  }

}
